import React, {useEffect, useState} from "react";
import InfoTooltip from "../tooltips/InfoTooltip";
import DeadlineDatepickerField from "../fields/DeadlineDatepickerField";
import {useSelector} from "react-redux";
import {useForm, useFormState} from "react-final-form";
import {optionItemFinder} from "../../helpers/OptionHelper";
import QueryStorage from "../../../../../common/helpers/QueryStorage";
import Tooltips from "../../helpers/fieldTooltips";

function Deadline() {
    const {change} = useForm();
    const {values} = useFormState();
    const {academicLevel, deadlines, typeOfPaper, subject} = useSelector(state => state.orderOptions.data);
    const academicLevelItem = optionItemFinder(values.academicLevel, academicLevel);
    const typeOfPaperItem = optionItemFinder(values.typeOfPaper, typeOfPaper);
    const subjectItem = optionItemFinder(values.subject, subject);
    const [options, setOptions] = useState([]);

    const getMinDeadline = (academicLevelItem) => {
        const keys = Object.keys(academicLevelItem?.deadlineDependency || {});
        return keys.length ? keys[0] : null;
    };

    const isValidDeadline = (val) => {
        return val && !isNaN(val) && deadlines.some(d => d.value == val);
    };

    const isDeadlineAvailable = (deadline, minDeadline) => {
        return deadline.value >= minDeadline &&
            !(
                (deadline.is3h &&
                    ((typeOfPaperItem && typeOfPaperItem.disable3h) ||
                        (subjectItem && subjectItem.disable3h))) ||
                (deadline.is8h &&
                    ((typeOfPaperItem && typeOfPaperItem.disable8h) ||
                        (subjectItem && subjectItem.disable8h)))
            );
    };

    const getAvailableDeadlines = (minDeadline) => {
        return deadlines.filter(deadline => isDeadlineAvailable(deadline, minDeadline));
    };

    const updateOptions = (minDeadline) => {
        if (minDeadline == null) return;
        setOptions(getAvailableDeadlines(minDeadline));
    };

    const updateForm = (minDeadline) => {
        if (minDeadline == null) return;
        let deadlineItem = deadlines.find(item => item.value == values.deadline);

        if (!deadlineItem || !isDeadlineAvailable(deadlineItem, minDeadline)) {
            let firstAvailableDeadline = getAvailableDeadlines(minDeadline).slice(-1)[0];
            if (firstAvailableDeadline) {
                change('deadline', firstAvailableDeadline.value);
                change('exactDeadline', firstAvailableDeadline.value);
            }
        }
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const urlDeadline = urlParams.get("deadline");
        const savedDeadline = QueryStorage.get("deadline");
        const savedExactDeadline = QueryStorage.get("exactDeadline");

        const minDeadline = getMinDeadline(academicLevelItem);

        if (isValidDeadline(urlDeadline)) {
            const deadlineValue = Number(urlDeadline);
            change("deadline", deadlineValue);
            change("exactDeadline", deadlineValue);
            QueryStorage.set("deadline", deadlineValue);
            QueryStorage.set("exactDeadline", deadlineValue);
        } else if (isValidDeadline(savedDeadline) && isValidDeadline(savedExactDeadline)) {
            change("deadline", Number(savedDeadline));
            change("exactDeadline", Number(savedExactDeadline));
        } else if (minDeadline) {
            updateOptions(minDeadline);
            updateForm(minDeadline);
        }
    }, []);

    useEffect(() => {
        const minDeadline = getMinDeadline(academicLevelItem);
        if (minDeadline) {
            updateOptions(minDeadline);
            updateForm(minDeadline);
        }
    }, [values.academicLevel, values.typeOfPaper, values.subject]);

    useEffect(() => {
        if (values.deadline && values.exactDeadline) {
            QueryStorage.set("deadline", values.deadline);
            QueryStorage.set("exactDeadline", values.exactDeadline);
        }
    }, [values.deadline, values.exactDeadline]);

    return (
        <div className="form-col-2 form-control-deadline">
            <div className="form-group">
                <div className="form-label d-flex">
                    Deadline
                    <InfoTooltip>
                        <p>{Tooltips.deadline}</p>
                    </InfoTooltip>
                </div>
                <DeadlineDatepickerField
                    name="deadline"
                    exactName="exactDeadline"
                    deadlines={options}
                />
            </div>
        </div>
    );
}

export default Deadline;
